import React from 'react';

export default function ArrowLeft(props) {
  return (
    <svg {...props} width="64" height="64" viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg">
      <g id="Icon32/Chevron-Right">
        <path
          id="Chevron-Right"
          d="M37.922 52L40.75 49.172L23.578 32L40.75 14.828L37.922 12L20.75 29.172L17.922 32L20.75 34.828L37.922 52Z"
        />
      </g>
    </svg>
  );
}
